import { getDefaultExportFromCjs } from " commonjsHelpers.js";
import { __require as requireAvia_hls } from "/home/runner/work/avia-js/avia-js/libs/plugins/hls/dist/avia.hls.cjs";
var avia_hlsExports = requireAvia_hls();
export { avia_hlsExports as __moduleExports };
export default /*@__PURE__*/getDefaultExportFromCjs(avia_hlsExports);